import { SkillGroup } from "../../../types/core";

export default function getSkillGroups(): SkillGroup[] {
	return [
		{
			tag: "Languages",
			skills: [
				{ title: "C#" },
				{ title: "Java" },
				{ title: "TypeScript" },
				{ title: "JavaScript" },
				{ title: "HTML/CSS" },
			]
		},
		{
			tag: "Frameworks",
			skills: [
				{
					title: ".NET",
					details: ["ASP.NET Core", "Entity Framework", "LINQ"]
				},
				{ title: "React/Redux" },
				{ title: "Spring" },
				{ title: "REST APIs" },
			]
		},
		{
			tag: "Cloud & DevOps",
			skills: [
				{ title: "Git" },
				{ title: "SVN" },
				{ title: "AWS" },
				{ title: "Jenkins" },
			]
		},
		{
			tag: "Tools & Practices",
			skills: [
				{
					title: "AI Development",
					details: ["Claude, Windsurf", "Agents, MCP"]
				},
				{ title: "Agile/Scrum" },
				{ title: "Accessibility (WCAG)" },
				{ title: "Jira" },
			]
		},
		{
			tag: "Databases",
			skills: [
				{ title: "Epic Caché/M" },
				{ title: "SQL" },
			]
		}
	]
}
